import { INVENTARIO } from '../actions/types';

const initialState = {
    listado: [],
    categorias: [],
    subcategorias: [],
    proveedores: [],
    filtros: {
        id_categoria: '',
        id_subcategoria: '',
        id_proveedor: ''
    },
    detalles: null,
    proveedoresProducto: [],
    loadingProveedoresProducto: false,
    movimientosListado: [],
    movimientosAreas: [],
    movimientosOrganizadoresOrigen: [],
    movimientosUbicacionesOrigen: [],
    movimientosOrganizadoresDestino: [],
    movimientosUbicacionesDestino: [],
    movimientosProductosOrigen: []
};

export default function inventarioReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case INVENTARIO.LISTAR:
            return {
                ...state,
                listado: payload || []
            };

        case INVENTARIO.LIMPIAR:
            return {
                ...state,
                listado: []
            };

        case INVENTARIO.CATEGORIAS_CARGADAS:
            return {
                ...state,
                categorias: payload || []
            };

        case INVENTARIO.SUBCATEGORIAS_CARGADAS:
            return {
                ...state,
                subcategorias: payload || []
            };

        case INVENTARIO.PROVEEDORES_CARGADOS:
            return {
                ...state,
                proveedores: payload || []
            };

        case INVENTARIO.SET_FILTROS:
            return {
                ...state,
                filtros: {
                    ...state.filtros,
                    ...(payload || {})
                }
            };

        case INVENTARIO.LIMPIAR_FILTROS:
            return {
                ...state,
                filtros: {
                    id_categoria: '',
                    id_subcategoria: '',
                    id_proveedor: ''
                },
                subcategorias: []
            };

        case INVENTARIO.ERROR:
            return {
                ...state
            };
        
        case INVENTARIO.DETALLES:
            return {
                ...state,
                detalles: payload || null,
                proveedoresProducto: [],
                loadingProveedoresProducto: true
            };

        case INVENTARIO.LIMPIAR_DETALLES:
            return {
                ...state,
                detalles: null,
                proveedoresProducto: [],
                loadingProveedoresProducto: false
            };
        case INVENTARIO.LIMPIAR_PROVEEDORES_PRODUCTO:
            return {
                ...state,
                proveedoresProducto: [],
                loadingProveedoresProducto: false
            };

        case INVENTARIO.PROVEEDORES_PRODUCTO_CARGANDO:
            return {
                ...state,
                proveedoresProducto: [],
                loadingProveedoresProducto: true
            };

        case INVENTARIO.PROVEEDORES_PRODUCTO_CARGADOS:
            return {
                ...state,
                proveedoresProducto: Array.isArray(action.payload) ? action.payload : [],
                loadingProveedoresProducto: false
            };

        case INVENTARIO.PROVEEDORES_PRODUCTO_ERROR:
            return {
                ...state,
                proveedoresProducto: [],
                loadingProveedoresProducto: false
            };

    //Movimientos

        case INVENTARIO.MOVIMIENTOS_LISTAR:
            return {
                ...state,
                movimientosListado: payload || []
            };

        case INVENTARIO.MOVIMIENTOS_LIMPIAR:
            return {
                ...state,
                movimientosListado: []
            };

        case INVENTARIO.MOVIMIENTOS_AREAS_CARGADAS:
            return {
                ...state,
                movimientosAreas: payload || []
            };

        case INVENTARIO.MOVIMIENTOS_ORGANIZADORES_ORIGEN_CARGADOS:
            return {
                ...state,
                movimientosOrganizadoresOrigen: payload || [],
                movimientosUbicacionesOrigen: []
            };

        case INVENTARIO.MOVIMIENTOS_UBICACIONES_ORIGEN_CARGADAS:
            return {
                ...state,
                movimientosUbicacionesOrigen: payload || []
            };

        case INVENTARIO.MOVIMIENTOS_ORGANIZADORES_DESTINO_CARGADOS:
            return {
                ...state,
                movimientosOrganizadoresDestino: payload || [],
                movimientosUbicacionesDestino: []
            };

        case INVENTARIO.MOVIMIENTOS_UBICACIONES_DESTINO_CARGADAS:
            return {
                ...state,
                movimientosUbicacionesDestino: payload || []
            };

        case INVENTARIO.MOVIMIENTOS_PRODUCTOS_ORIGEN_CARGADOS:
            return {
                ...state,
                movimientosProductosOrigen: payload || []
            };

        case INVENTARIO.MOVIMIENTOS_LIMPIAR_FORM:
            return {
                ...state,
                movimientosAreas: payload?.keepAreas ? (payload?.areas || []) : [],
                movimientosOrganizadoresOrigen: [],
                movimientosUbicacionesOrigen: [],
                movimientosOrganizadoresDestino: payload?.keepDestino ? state.movimientosOrganizadoresDestino : [],
                movimientosUbicacionesDestino: payload?.keepDestino ? state.movimientosUbicacionesDestino : [],
                movimientosProductosOrigen: []
            };

        case INVENTARIO.MOVIMIENTOS_CREADO:
            return {
                ...state
            };

        case INVENTARIO.MOVIMIENTOS_ERROR:
            return {
                ...state
            };

                default:
                    return state;
            }
        
}
